import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "Who is a 'care-leaver'?",
      answer: "A care-leaver is a young person who has grown up in institutional care (child care institutions, orphanages, group homes) and exits the system, typically at the age of 18. At this stage, most care-leavers have limited family support, restricted access to higher education or jobs, and minimal guidance for independent living."
    },
    {
      question: "What does 'aftercare' mean in this context?",
      answer: "Aftercare refers to structured support provided after a young person leaves institutional care. This can include: education and skill development, employability and livelihood support, mentoring and guidance, help with documentation, housing, and transition planning. Aftercare ensures that leaving care does not result in vulnerability or instability."
    },
    {
      question: "Why focus on care-leavers under CSR?",
      answer: "Care-leavers fall squarely within CSR focus areas such as: education and skill development, employability and livelihood enhancement, youth development and inclusion, reducing inequalities faced by vulnerable groups. Despite this alignment, care-leavers remain an under-served population, making CSR interventions both relevant and high-impact."
    },
    {
      question: "How does CLiC work with corporates under CSR?",
      answer: "CLiC partners with corporates through: cohort-based or state-specific program sponsorships, thematic partnerships (education, employability, livelihoods), multi-year initiatives aligned with CSR priorities. Each partnership includes defined budgets, implementation plans, and outcome reporting aligned with CSR requirements."
    },
    {
      question: "Is CLiC compliant for CSR funding?",
      answer: "Yes. CLiC is a registered nonprofit organisation with: valid 12A and 80G registrations, CSR-1 registration, audited financial statements, experience working with institutional funders. All CSR engagements are structured to meet statutory and governance expectations."
    },
    {
      question: "What is the typical CSR engagement size?",
      answer: "CSR partnerships with CLiC typically range from Rs.25 lakh to Rs.1.5 crore, depending on scope, geography, and duration. Both single-year and multi-year engagements are possible."
    },
    {
      question: "How are outcomes and reporting handled?",
      answer: "CLiC provides: periodic progress updates, utilisation reporting aligned to CSR norms, outcome and beneficiary tracking, documentation suitable for CSR committee and board review. Reporting formats can be aligned with the partner's internal requirements."
    },
    {
      question: "Which geographies does CLiC currently work in?",
      answer: "CLiC currently operates across multiple Indian states and works closely with state governments and partners to implement aftercare programs. Geographic alignment can be discussed and tailored based on CSR priorities."
    },
    {
      question: "How is CLiC different from other NGOs in this space?",
      answer: "CLiC is: care-leaver-led, bringing lived experience into program design, focused on transition and independence, not only immediate relief, structured for institutional partnerships, not one-off charity. This combination allows CLiC to deliver both authenticity and execution discipline."
    }
  ];

  return (
    <section id="faq" className="py-12 md:py-16 bg-white" data-testid="faq-section">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Centered Container */}
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-display text-2xl md:text-3xl font-bold text-[#4A4A4A] mb-3">
              Frequently Asked Questions
            </h2>
            <p className="text-[#6B7280]">
              Common questions about care-leavers, aftercare, and CSR partnerships with CLiC.
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-[#E5E7EB] rounded-lg px-5 bg-[#F8F9F7] hover:border-[#1F7A5A]/30 transition-colors"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left font-medium text-[#4A4A4A] hover:text-[#1F7A5A] py-4 text-sm md:text-base">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#6B7280] pb-4 text-sm leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
